// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"9490c6ad","181":"983ff3db","462":"f1c7eb47"}[chunkId] + ".chunk.js";
};